import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AppRoutes } from 'src/app/app-routes';
import { QUERY_PARAMS, SIMULATOR_BY_TYPE } from 'src/app/utils/constants';

export const requireQueryParamsGuard: CanActivateFn = (route, _state): true | UrlTree => {
	const router = inject(Router);

	const product = route.queryParamMap.get(QUERY_PARAMS.PRODUCT)?.trim();
	const isValid = !!product && product in SIMULATOR_BY_TYPE;

	return isValid ? true : router.createUrlTree([AppRoutes.ERROR]);
};
